import { Injectable } from '@angular/core';
import { DomainService } from '@portal-shared/app/services/domain.service';

@Injectable({
  providedIn: 'root'
})
export class AllyaStorageService {
    
  public constructor(private domainService: DomainService) {}

  private getKey(candidateKey: string) {
    const domainKey = this.domainService.getDomainKeyOrDefault();
    return `${domainKey}_${candidateKey}`;
  }
  public setItem<T>(key: string, item?: T) {
    key = this.getKey(key);

    if (!item) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.setItem(key, JSON.stringify(item));
  }

  public getItem<T>(key: string) {
    key = this.getKey(key);

    const item = localStorage.getItem(key);
    if (!item) {
      return undefined;
    }
    return JSON.parse(item) as T;
  }
}
